import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MfAccountingServiceComponent } from './mf-accounting-service.component';

const routes: Routes = [
  {
    path: '',
    component: MfAccountingServiceComponent,
    children: [
      {
        path: '**',
        component: MfAccountingServiceComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MfAccountingServiceRoutingModule {}
